import {StoreType} from '../../../types/sharedTypes';

export const allThresholdsSelector = (state: StoreType) => {
  return state.thresholdReducer.thresholdResult;
}
